import { useTranslation } from "react-i18next";
import { Guarantee } from "../../../redux/apiSpecifications/apiClaims";
import { useMemo } from "react";
import { MaterialReactTable, MRT_ColumnDef } from "material-react-table";
import { CellWrapper, IconButtonCellWrapper } from "../../../style/CellWrapper";
import { TableWrapper } from "../../../style/TableWrapper";
import { IconButtonWithConfirm } from "../../Inputs/IconButtons";
import { IconPracticesRejected } from "../../../config/icons";
import { useSelector } from "react-redux";
import { RootState } from "../../../redux/store";
import { MRT_Localization_IT } from "material-react-table/locales/it";
import { MRT_Localization_EN } from "material-react-table/locales/en";

interface IPolicyGuaranteesListProps {
  guarantees: Guarantee[];
  onSelectItem?: (item: GuaranteesListItem) => void;
  onDeleteItem?: (item: GuaranteesListItem) => void;
}

const PolicyGuaranteesList = ({
  guarantees,
  onSelectItem,
  onDeleteItem,
}: IPolicyGuaranteesListProps) => {
  const { t } = useTranslation();

  const { language } = useSelector((state: RootState) => state.user) || {};

  const items = useMemo(
    () =>
      guarantees.map((item) => {
        return {
          ...item,
          branchDescription: t(`policy-branch-${item.branch}`)!,
        } as GuaranteesListItem;
      }) || [],
    [guarantees]
  );

  const columns = useMemo<MRT_ColumnDef<GuaranteesListItem>[]>(() => {
    const columns: MRT_ColumnDef<GuaranteesListItem>[] = [
      {
        accessorKey: "branchDescription",
        header: t("policy-guarantees-list-branch-description"),
        size: 100,
        Cell: ({ row }) => (
          <CellWrapper>{row.original.branchDescription}</CellWrapper>
        ),
      },
      {
        accessorKey: "excessAmount",
        header: t("policy-guarantees-list-excess-amount"),
        size: 100,
        Cell: ({ row }) => (
          <CellWrapper>{row.original.excessAmount}</CellWrapper>
        ),
      },
      {
        accessorKey: "overdraftAmount",
        header: t("policy-guarantees-list-overdraft-amount"),
        size: 100,
        Cell: ({ row }) => (
          <CellWrapper>{row.original.overdraftAmount}</CellWrapper>
        ),
      },
    ];

    // if (onDeleteItem) {
    //   columns.push({
    //     header: "Actions",
    //     Header: <span></span>,
    //     size: 50,
    //     enableColumnOrdering: false,
    //     Cell: ({ row }) => (
    //       <IconButtonCellWrapper>
    //         <IconButtonWithConfirm
    //           onClick={(event) => {
    //             onDeleteItem(row.original);
    //             event?.stopPropagation();
    //           }}
    //           popconfirmOption={{
    //             title: t("MESSAGES.confirm-delete-policy-guarantee"),
    //             placement: "leftTop",
    //           }}
    //         >
    //           <IconPracticesRejected />
    //         </IconButtonWithConfirm>
    //       </IconButtonCellWrapper>
    //     ),
    //   });
    // }

    return columns;
  }, [guarantees, language]);

  const handleSelectItem = (item: GuaranteesListItem) => {
    if (onSelectItem) onSelectItem(item);
  };

  return (
    <TableWrapper>
      <MaterialReactTable
        columns={columns}
        data={items}
        enableDensityToggle={false}
        enableFullScreenToggle={false}
        enableHiding={false}
        enableFilters={true}
        enableColumnActions={false}
        enableColumnDragging={false}
        enableSorting={true}
        enableTopToolbar={true}
        localization={
          language === "it" ? MRT_Localization_IT : MRT_Localization_EN
        }
        muiTableBodyRowProps={({ row }) => ({
          onClick: (event) => {
            handleSelectItem(row.original);
          },
          sx: {
            cursor: onSelectItem !== undefined ? "pointer" : "default",
          },
        })}
      />
    </TableWrapper>
  );
};

export default PolicyGuaranteesList;

export type GuaranteesListItem = Guarantee & { branchDescription?: string };
